// eslint-disable-next-line
import { injectable } from "inversify";
import { rootContainer, TYPE } from "../container/root";
import { IApiResponse, IHttpService } from "../http-service";

export interface IDashboardTranslationsService {
    getDashboardTranslations(): Promise<IDashboardTranslationLocale>;
}

export interface IDashboardTranslationLocale {
    dashboard_locale: string;
    locales: {[key: string]: string};
    translations: ITranslationRecord[];
}

export interface ITranslationRecord {
    is_customizable?: boolean,
    key: string,
    locale: string,
    priority?: string,
    scope: string,
    translation: string,
    type?: string,

    _deteted?: boolean;
}

@injectable()
class DashboardTranslationsService implements IDashboardTranslationsService {
    private readonly httpService: IHttpService = rootContainer.get<IHttpService>(TYPE.ApiHttp);

    public async getDashboardTranslations(): Promise<IDashboardTranslationLocale> {
        const res = await this.httpService.get<IApiResponse<IDashboardTranslationLocale>>(`/rms-api/dashboard-translations`);
        return res.payload;
    }

    public async setDashboardTranslations(locale:string): Promise<IDashboardTranslationLocale> {
        const res = await this.httpService.put<IApiResponse<IDashboardTranslationLocale>>(`/rms-api/dashboard-translations`, { locale });
        return res.payload;
    }

}

export default DashboardTranslationsService;